import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Title, View } from '@common/components';
import { Row, Col, Layout } from 'antd';
import { Helmet } from 'react-helmet';
import {
	fetchGuests,
	fetchGuestsByOrganization,
	clearGuests,
} from '@resources/Guest/actions';
import { FormattedMessage, useIntl } from 'react-intl';
import { GuestItem } from '@fragments/items';
import CreateModal from './Create';
import UpdateModal from './Update';

const { Content } = Layout;

const Guest = (props) => {
	const {
		guests,
		fetchGuests,
		fetchGuestsByOrganization,
		clearGuests,
		organization,
	} = props;
	const intl = useIntl();
	const [create, setCreate] = useState(false);
	const [update, setUpdate] = useState(false);

	useEffect(() => {
		const func = async () => {
			await clearGuests();

			organization?._id
				? await fetchGuestsByOrganization(organization?._id)
				: await fetchGuests();
		};

		func();
	}, [fetchGuests, fetchGuestsByOrganization, clearGuests, organization]);

	const parseDataSource = useCallback(() => {
		return guests.map((guest) => {
			return {
				key: guest._id,
				...guest,
			};
		});
	}, [guests]);

	return (
		<Content>
			<Helmet>
				<title>
					{intl.formatMessage({
						id: 'common.guest.management',
						defaultMessage: 'Guest Management',
					})}
				</title>
			</Helmet>
			<CreateModal
				{...props}
				module={module}
				visible={create}
				onCancel={() => setCreate(false)}
			/>

			<UpdateModal
				{...props}
				module={module}
				visible={update}
				onCancel={() => setUpdate(false)}
			/>
			<Container>
				<View>
					<Row
						type="flex"
						justify="center"
						align="middle"
						className="mt-5">
						<Col md={{ span: 12 }}>
							<Title>
								<FormattedMessage
									id="common.guests"
									defaultMessage="Guests"
								/>
							</Title>
						</Col>
						<Col md={{ span: 12 }} className="text-right">
							<Button
								type="primary"
								onClick={() => setCreate(true)}>
								<FormattedMessage
									id="common.new.guest"
									defaultMessage="New Guest"
								/>
							</Button>
						</Col>
					</Row>
					{parseDataSource() &&
						parseDataSource().map((guest, index) => (
							<GuestItem
								key={`guest-${index}`}
								guest={guest}
								onEdit={() => setUpdate(guest._id)}
							/>
						))}
				</View>
			</Container>
		</Content>
	);
};

const mapStateToProps = ({
	guests,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		guests,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	fetchGuests,
	fetchGuestsByOrganization,
	clearGuests,
})(Guest);
